module.exports = __webpack_public_path__ + "static/media/liciousImg.deb46666.svg";